var _path, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewLocationPin = function SvgNewLocationPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0214 36.501L23.1811 37.621L24.0086 38.2417L24.845 37.6332L24.0214 36.501ZM24.0214 36.501C24.845 37.6332 24.8453 37.633 24.8456 37.6328L24.8464 37.6322L24.8485 37.6307L24.8548 37.626L24.8761 37.6104C24.8941 37.5971 24.9194 37.5783 24.9518 37.554C25.0164 37.5055 25.1091 37.4352 25.2261 37.3444C25.4601 37.1628 25.7921 36.8988 26.1934 36.5624C26.9945 35.8907 28.0787 34.9242 29.2124 33.7429C31.4396 31.4223 34.0275 28.1001 34.8407 24.44L34.8439 24.4254L34.8468 24.4108C35.6648 20.3199 34.4337 16.9491 32.2146 14.6236C30.0348 12.3393 26.9389 11.0989 24.0214 11.0989C18.1844 11.0989 12.3486 16.1038 13.1773 23.5636C13.594 27.3148 16.2385 30.8742 18.5403 33.3608C19.7208 34.6361 20.8742 35.6954 21.7317 36.4357C22.1613 36.8066 22.5188 37.0992 22.771 37.3007C22.8972 37.4015 22.9971 37.4797 23.0668 37.5336C23.1017 37.5605 23.129 37.5814 23.1482 37.596L23.1709 37.6132L23.1776 37.6183L23.1798 37.6199L23.1805 37.6205C23.1808 37.6207 23.1811 37.621 24.0214 36.501Z",
    fill: "#FAFBFC",
    stroke: "#2F353B",
    strokeWidth: 2.80023
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1,
    cy: 22.0998,
    r: 3.00024,
    fill: "#E34B34",
    stroke: "#E34B34",
    strokeWidth: 2.80023
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewLocationPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-locationPin.b2b6bccc.svg";
export { ForwardRef as ReactComponent };